import React from 'react';
import { useSelector } from 'react-redux';

import {
  getRentalsFetched,
  getRentalsTiles,
  getSimilarRentalsFetched,
  getSimilarRentalsTiles,
} from '@/redux/selectors/listing/similarRentals';
import { EListingSource } from '@/services/analytics/listings/types';

import RentalsCarousel from './RentalsCarousel';

type TSimilarRentalsCarouselProps = {
  maxCols?: number;
  maxRentals?: number;
  verticalScrollGrid?: boolean;
  inline?: boolean;
  title?: string;
  useRentalsFromId?: boolean;
  extraQueryParams?: string;
  eventSource?: EListingSource;
  isRow?: boolean;
  autoCssJudgeStyle?: boolean;
};

const SimilarRentalsCarousel = (props: TSimilarRentalsCarouselProps) => {
  return <DefaultSimilarRentalsCarousel {...props} />;
};

export default SimilarRentalsCarousel;

const DefaultSimilarRentalsCarousel = ({
  title,
  maxCols,
  maxRentals,
  verticalScrollGrid = false,
  inline = false,
  useRentalsFromId = false,
  extraQueryParams,
  eventSource,
  isRow = false,
  autoCssJudgeStyle = false,
}: TSimilarRentalsCarouselProps) => {
  const rentalsList = useSelector(useRentalsFromId ? getSimilarRentalsTiles : getRentalsTiles);
  const isFetched = useSelector(useRentalsFromId ? getSimilarRentalsFetched : getRentalsFetched);

  return (
    <RentalsCarousel
      title={title}
      maxCols={maxCols}
      maxRentals={maxRentals}
      verticalScrollGrid={verticalScrollGrid}
      inline={inline}
      rentalsList={rentalsList}
      loading={!isFetched}
      extraQueryParams={extraQueryParams}
      eventSource={eventSource}
      isRow={isRow}
      autoCssJudgeStyle={autoCssJudgeStyle}
    />
  );
};
